import forDevice from '../../hoc/for-device';
import LoginToCommentMobile from './login-to-comment-mobile';
import LoginToCommentDesktop from './login-to-comment-desktop';

export default forDevice(LoginToCommentMobile, LoginToCommentDesktop);
